import { useState } from 'react';
import { RoutingRuleType } from 'src/graphql';
import { RoutingDataSource } from 'src/types';
import type { RoutingVariantType } from '../../RoutingRuleAndPriority';
import { readRoutingRuleDataSource } from '../helpers';

interface Parameters {
  rule: RoutingRuleType;
  variant?: RoutingVariantType;
}

export const useRoutingRuleDataSource = ({ rule, variant }: Parameters) => {
  const ruleUserDataSources =
    readRoutingRuleDataSource(rule.rule)?.filter(
      (source) => source && source !== RoutingDataSource.REPORT,
    ) ?? [];
  const isReporterDataSource = ruleUserDataSources.every(
    (source) => source === RoutingDataSource.REPORTER,
  );
  const [selectedDataSource, setSelectedDataSource] = useState(
    variant === 'coi' ||
      (ruleUserDataSources.length > 0 && isReporterDataSource)
      ? RoutingDataSource.REPORTER
      : RoutingDataSource.OFFENDER,
  );

  return { selectedDataSource, setSelectedDataSource };
};
